import React from 'react'
import { Button } from '@mch-group/uikit-components'
import { useTracking } from '@hooks'
import { formatArtworkTitle, getSiteLanguage } from '@utils'
import EnquiryModal from '@components/EnquiryModal'
import { useLabelsFromAPI } from '@dmi-mch/hooks'
import { useModuleContext } from '../contexts/module'

/**
 * @returns {JSX.Element}
 * @constructor
 */
function SalesQueryButton() {
  const { state: { artworkInformation } } = useModuleContext()
  const { labels = {} } = useLabelsFromAPI(['ShowRoomArtwork', 'AltTags'], getSiteLanguage())
  const {
    artworkInfo,
    id,
    name,
    year,
    endYear,
    artist,
    eventId,
    showInRoom,
    firstImageUrl,
    showWhenExhibition,
    showWhenShowroom,
    showWhenCatalog,
    artworkContactFormLabel
  } = artworkInformation || {}

  const { setAction } = useTracking(id)

  return (
    <EnquiryModal
      onShowModal={() => {
        setAction(3)
      }}
      onSubmitSuccess={() => {
        setAction(4)
      }}
      image={firstImageUrl}
      title={formatArtworkTitle(name, year, endYear)}
      imgAlt={`${name} ${labels?.AltTags?.altTagBy} ${artist} ${year ? `(${year})` : ''}`}
      subtitle={artworkInfo?.artistName}
      isShowArtworkDetail
      id={id}
      eventId={eventId}
      showInRoom={showInRoom}
      showWhenCatalog={showWhenCatalog}
      showWhenExhibition={showWhenExhibition}
      showWhenShowroom={showWhenShowroom}
      submitButtonAttributes={{
        'data-event': 'event',
        'data-category': 'ovr',
        'data-action': 'submit-button',
        'data-label': `${artworkInfo?.eventDataAssociated.id}/${artworkInfo?.eventDataAssociated.cleanTitle}`,
        'data-value': `${id}/${artworkInfo?.cleanTitle}`
      }}
      contactBtnClass='contact-sales-inquiry'
      button={
        <Button className='me-3'>
          {artworkContactFormLabel?.inContactLabel}
        </Button>
      }
    />
  )
}

export default SalesQueryButton